export const REPORT_STATUS = {
  all: "all",
  pending: "pending",
  sent: "sent",
  failed: "failed",
}

export function reportRowKey(row) {
  return `${row.concierge_user_id}-${row.account_owner_id}-${row.report_date}`
}

export function pendingItemToRow(item) {
  return {
    id: `pending-${reportRowKey(item)}`,
    status: REPORT_STATUS.pending,
    report_date: item.report_date,
    concierge_user_id: item.concierge_user_id,
    account_owner_id: item.account_owner_id,
    concierge_name: item.concierge_name,
    concierge_email: item.concierge_email,
    account_owner_name: item.account_owner_name,
    account_owner_email: item.account_owner_email,
    has_notes: item.has_notes,
    last_error: item.last_error || "",
    notes: "",
    sent_at: null,
    to_email: null,
  }
}

export function logToRow(log) {
  return {
    id: log.id,
    status: log.status,
    report_date: log.report_date,
    concierge_user_id: log.concierge_user_id,
    account_owner_id: log.account_owner_id,
    concierge_name: log.concierge_name,
    concierge_email: log.concierge_email,
    account_owner_name: log.account_owner_name,
    account_owner_email: log.account_owner_email,
    has_notes: Boolean((log.notes || "").trim()),
    last_error: log.last_error || "",
    notes: log.notes || "",
    sent_at: log.sent_at,
    to_email: log.to_email,
    created: log.created,
  }
}

export function mergeActivityReportRows(pendingItems = [], logRows = []) {
  const byKey = new Map()

  for (const log of logRows) {
    const row = logToRow(log)
    const key = reportRowKey(row)
    const existing = byKey.get(key)
    if (!existing || row.status === REPORT_STATUS.sent) {
      byKey.set(key, row)
    }
  }

  for (const item of pendingItems) {
    const row = pendingItemToRow(item)
    const key = reportRowKey(row)
    const existing = byKey.get(key)
    if (existing?.status === REPORT_STATUS.sent) {
      continue
    }
    if (!existing) {
      byKey.set(key, row)
    }
  }

  return Array.from(byKey.values()).sort((left, right) => {
    const dateCompare = String(right.report_date || "").localeCompare(
      String(left.report_date || "")
    )
    if (dateCompare !== 0) {
      return dateCompare
    }
    const leftSent = left.sent_at || left.created || ""
    const rightSent = right.sent_at || right.created || ""
    return String(rightSent).localeCompare(String(leftSent))
  })
}

function rowMatchesSearch(row, searchText) {
  const term = String(searchText || "")
    .trim()
    .toLowerCase()
  if (!term) {
    return true
  }
  return [
    row.concierge_name,
    row.concierge_email,
    row.account_owner_name,
    row.account_owner_email,
    row.to_email,
    row.notes,
    row.report_date,
    row.status,
  ]
    .filter(Boolean)
    .some((value) => String(value).toLowerCase().includes(term))
}

export function filterActivityReportRows(
  rows,
  {
    searchText = "",
    conciergeUserId = null,
    statusFilter = REPORT_STATUS.all,
  } = {}
) {
  return rows.filter((row) => {
    if (
      conciergeUserId &&
      String(row.concierge_user_id) !== String(conciergeUserId)
    ) {
      return false
    }
    if (statusFilter !== REPORT_STATUS.all && row.status !== statusFilter) {
      return false
    }
    return rowMatchesSearch(row, searchText)
  })
}
